import { render, staticRenderFns } from "./Type1Verify.vue?vue&type=template&id=3300f1a7&scoped=true"
import script from "./Type1Verify.vue?vue&type=script&lang=js"
export * from "./Type1Verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3300f1a7",
  null
  
)

export default component.exports